<template>
  <div class="extract">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item>
        <el-select
          v-model="query.state"
          @change="handleStateChange"
          placeholder="全部"
        >
          <el-option :value="1" label="待处理"></el-option>
          <el-option :value="2" label="处理通过"></el-option>
          <el-option
            :value="3"
            label="处理未通过"
            v-if="GLOBAL.kefu_flag"
          ></el-option>
          <el-option :value="4" label="机器人报价中"></el-option>
          <el-option :value="5" label="报价成功"></el-option>
          <el-option
            :value="33"
            label="成功"
            v-if="GLOBAL.kefu_flag"
          ></el-option>
          <el-option
            :value="35"
            label="商城发货失败"
            v-if="GLOBAL.kefu_flag"
          ></el-option>
          <el-option
              :value="36"
              label="手动发货确认"
              v-if="GLOBAL.kefu_flag"
          ></el-option>
          <el-option
              :value="998"
              label="转赠确认"
              v-if="GLOBAL.kefu_flag"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="query.delivery_type"
          @change="handleDeliveryChange"
          placeholder="发货类型"
        >
          <el-option :value="1" label="手动发货"></el-option>
          <el-option :value="2" label="机器人自动"></el-option>
          <el-option :value="3" label="zbt发货"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="query.uid" placeholder="用户ID"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select
          v-model="query.goods_type"
          @change="changeType"
          placeholder="请选择物品类型"
        >
          <el-option :value="undefined">全部</el-option>
          <el-option :value="1" label="csgo物品"></el-option>
          <el-option :value="2" label="dota物品"></el-option>
          <el-option :value="3" label="活动商城物品"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="query.user_name" placeholder="用户名称"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="query.user_tag" placeholder="用户标签"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input
          v-model="query.min_price"
          placeholder="最低价格"
          style="width: 200px"
        ></el-input>
        -
        <el-input
          v-model="query.max_price"
          placeholder="最高价格"
          style="width: 200px"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-date-picker
          v-model="query.start_time"
          type="datetime"
          placeholder="开始日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
        —
        <el-date-picker
          v-model="query.end_time"
          type="datetime"
          placeholder="结束日期"
          value-format="yyyy-MM-dd HH:mm:ss"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleSearch" type="primary" icon="el-icon-search"
          >搜索</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button @click="handleExport">导出</el-button>
      </el-form-item>
      <el-form-item>
        <el-button @click="handleSelectedChange">修改状态</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="showWarningUser"
          :loading="warningUserDialog"
          >显示预警用户</el-button
        >
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="showDeliveryAmount"
          :loading="warningUserDialog"
          >显示发货金额</el-button
        >
      </el-form-item>
      <el-form-item
        label="待发货金额："
        v-if="
          showData.manual_confirm_amount === 0 || showData.manual_confirm_amount
        "
      >
        <span style="font-size: 16px">{{
          showData.manual_confirm_amount
        }}</span>
      </el-form-item>
      <el-form-item
        label="最近10分钟发货金额："
        v-if="
          showData.lately_ten_deliver_amount === 0 ||
          showData.lately_ten_deliver_amount
        "
      >
        <span style="font-size: 16px">{{
          showData.lately_ten_deliver_amount
        }}</span>
      </el-form-item>
      <el-form-item>
        <el-button>Dms余额：{{mdsBanlance}}</el-button>
      </el-form-item>
    </el-form>

    <el-table
      :data="dataList"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      :row-class-name="tableRowClassName"
    >
      <el-table-column type="selection" align="center" />
      <el-table-column prop="backpack_id" label="背包ID"> </el-table-column>
      <el-table-column label="用户ID" width="100px">
        <template slot-scope="{ row }">
          <span
            :style="row.user.is_red === 1 ? 'color:red;' : ''"
            @click="pathToUser(row.user_id)"
            >{{ row.user_id }}</span
          >
        </template>
      </el-table-column>
      <el-table-column prop="user_info" label="用户信息">
        <template slot-scope="{ row }">
          <!-- <div class="user-avatar" v-if="row.user" @click="$router.push(`/user/${row.user_id}`)"> -->
          <div
            class="user-avatar"
            v-if="row.user"
            @click="pathToUser(row.user_id)"
          >
            <img :src="row.user.avatar || '/images/default-avatar.jpg'" alt />
            <span
              :style="`${row.user.human_feelings === 1 ? 'color:blue' : ''}`"
              >{{ row.user.name }}</span
            >
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user_type" label="用户类型">
        <template slot-scope="{ row }" v-if="row.user">
          <el-tag v-if="row.user.type === 1" type="info">普通用户</el-tag>
          <el-tag v-if="row.user.type === 2" type="success">主播</el-tag>
          <el-tag v-if="row.user.type === 7" type="success">主播（新）</el-tag>
          <el-tag v-if="row.user.type === 4" type="warning">代理</el-tag>
          <el-tag v-if="row.user.type === 6" type="warning">试用期代理</el-tag>
          <el-tag v-if="row.user.type === 3" type="primary">测试账号</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="user.user_tag"
        label="用户标签"
        width="60px"
      ></el-table-column>
      <el-table-column prop="prize" label="物品信息" width="280px">
        <template slot-scope="{ row }">
          <div class="prize-info" v-if="row.shop_prize">
            <img :src="row.shop_prize.image" alt />
            <div class="prize-text">
              <p>
                {{ row.shop_prize.name
                }}{{
                  row.shop_prize.rarity
                    ? "（" + getDotararity(row.shop_prize.rarity) + "）"
                    : ""
                }}
              </p>
              <!--							<p :style="`color: ${getRankColor(row.prize.rank)}`">-->
              <!--								{{ row.shop_prize.second_name }}-->
              <!--							</p>-->
              <p class="price" v-if="row.shop_prize.type === 1">暗金: 普通</p>
              <p class="price" v-if="row.shop_prize.type === 2">
                暗金: StatTrak™
              </p>
              <p class="price" v-if="row.shop_prize.type === 3">暗金: 纪念品</p>
              <p class="price" v-if="row.shop_prize.type === 4">暗金: ★</p>
              <p class="price" v-if="row.shop_prize.type === 5">
                暗金: ★StatTrak™
              </p>
              <p class="price">$ {{ row.pay_price }}</p>
            </div>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="appearance" label="品质">
        <template slot-scope="{ row }" v-if="row.shop_prize">
          <el-tag v-if="row.shop_prize.appearance === 1" type="info"
            >崭新出厂</el-tag
          >
          <el-tag v-if="row.shop_prize.appearance === 2" type="info"
            >略有磨损</el-tag
          >
          <el-tag v-if="row.shop_prize.appearance === 3" type="info"
            >久经沙场</el-tag
          >
          <el-tag v-if="row.shop_prize.appearance === 4" type="info"
            >破损不堪</el-tag
          >
          <el-tag v-if="row.shop_prize.appearance === 5" type="info"
            >战痕累累</el-tag
          >
          <el-tag v-if="row.shop_prize.appearance === 6" type="info"
            >无涂装</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column
          prop="number"
          label="数量"
          width="60px"
      ></el-table-column>
      <el-table-column prop="increase" label="转赠">
        <template slot-scope="{ row }">
          <el-tag v-if="row.increase === 1" type="info"
          >转赠</el-tag>
          <el-tag v-if="row.increase === 0" type="info"
          >非转增</el-tag>
        </template>
      </el-table-column>
      <!--			<el-table-column-->
      <!--				prop="backpack.joined_at"-->
      <!--				label="物品生成时间"-->
      <!--			></el-table-column>-->
      <el-table-column
        prop="created_at"
        label="操作时间"
        width="160px"
      ></el-table-column>
      <el-table-column
        prop="updated_at"
        label="修改时间"
        width="160px"
      ></el-table-column>
      <el-table-column prop="state" label="订单状态" width="130px">
        <template slot-scope="{ row }">
          <el-tag v-if="row.state === 1">待处理</el-tag>
          <el-tag v-if="row.state === 2" type="success">处理通过</el-tag>
          <el-tag v-if="row.state === 3" type="danger">处理未通过</el-tag>
          <el-tag v-if="row.state === 4" type="warning">机器人报价中</el-tag>
          <el-tag v-if="row.state === 5" type="success">报价成功</el-tag>
          <el-tag v-if="row.state === 6" type="danger">报价失败</el-tag>
          <el-tag v-if="row.state === 7" type="success">处理通过</el-tag>
          <el-tag v-if="row.state === 8" type="success">处理通过</el-tag>
          <el-tag v-if="row.state === 9" type="success">处理通过</el-tag>
          <el-tag v-if="row.state === 10" type="success">处理通过</el-tag>
          <el-tag v-if="row.state === 100" type="success">处理通过</el-tag>
          <el-tag v-if="row.state === 30" type="success">扎比特报价中</el-tag>
          <el-tag v-if="row.state === 31" type="success">扎比特等待发货</el-tag>
          <el-tag v-if="row.state === 32" type="success">扎比特等待收货</el-tag>
          <el-tag v-if="row.state === 33" type="success">扎比特交易成功</el-tag>
          <el-tag v-if="row.state === 34" type="success"
            >订单取消或订单失败</el-tag
          >
          <el-tag v-if="row.state === 40" type="success">已发送</el-tag>
          <el-tag v-if="row.state === 35" type="danger"
            >扎比特商城发货失败</el-tag
          >
          <el-tag v-if="row.state === 36" type="success"
            >扎比特手动发货确认</el-tag
          >
          <el-tag v-if="row.state === 50" type="success">IG订单取消</el-tag>
          <el-tag v-if="row.state === 51" type="success">IG等待卖家发货</el-tag>
          <el-tag v-if="row.state === 52" type="success"
            >IG等待买家接收报价</el-tag
          >
          <el-tag v-if="row.state === 53" type="success">IG交易成功</el-tag>
          <el-tag v-if="row.state === 54" type="danger">IG购买失败</el-tag>
          <el-tag v-if="row.state === 61" type="danger">PZH购买失败</el-tag>
          <el-tag v-if="row.state === 62" type="danger">PZH报价发送中</el-tag>
          <el-tag v-if="row.state === 64" type="danger">PZH等待卖家确认</el-tag>
          <el-tag v-if="row.state === 66" type="danger">PZH等待发货</el-tag>
          <el-tag v-if="row.state === 68" type="danger">PZH等待收货</el-tag>
          <el-tag v-if="row.state === 69" type="danger">PZH交易成功</el-tag>
          <el-tag v-if="row.state === 71" type="danger">PZH订单暂挂</el-tag>
          <el-tag v-if="row.state === 998" type="danger">转赠确认</el-tag>
          <el-tag v-if="row.state === 999" type="danger">已转赠</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="remark" label="备注信息"></el-table-column>
      <el-table-column prop="action" label="操作" width="130px" fixed="right">
        <template slot-scope="{ row }">
          <el-button
            style="margin-bottom: 5px"
            v-if="row.state === 36"
            type="primary"
            @click="handleIGShopManualInfo(row)"
            >IG购买
          </el-button>
          <el-button type="success" @click="syncIG(row)" v-if="row.state != 53"
            >同步IG状态</el-button
          >
          <el-button
              style="margin-bottom: 5px"
              v-if="row.state === 36"
              type="primary"
              @click="handleShopManualInfo(row)"
          >ZBT购买
          </el-button>
          <el-button
              style="margin-bottom: 5px"
              v-if="row.state === 36"
              type="primary"
              @click="handleShopManualInfo2(row)"
          >PZH购买
          </el-button>
          <el-button
              style="margin-bottom: 5px"
              v-if="row.state === 36"
              type="primary"
              @click="handleShopManualInfo3(row)"
          >MDS购买
          </el-button>
          <el-button v-if="row.state != 998" type="primary" @click="handleChange(row)"
            >修改订单</el-button
          >
          <!--					<el-button type="success" @click="zbtSearch(row)" v-if="row.type === 1 && row.delivery_type === 3 && row.state === 1"-->
          <!--					>扎比特</el-button-->
          <!--					>-->

          <el-button
              style="margin-bottom: 5px"
              type="primary"
              v-if="row.state === 998"
              @click="increaseConfirmed(row)"
          >确认转赠
          </el-button>
          <el-button
              style="margin-bottom: 5px"
              v-if="row.state === 998"
              type="primary"
              @click="increaseRefused(row)"
          >拒绝转赠
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      background
      :total="dataMeta ? dataMeta.total : 0"
      :current-page="dataMeta ? dataMeta.current_page : 1"
      :page-size="dataMeta ? dataMeta.per_page : 15"
      @current-change="handlePageChange"
    ></el-pagination>
    <el-dialog
      :visible.sync="visibleEdit"
      title="修改订单状态"
      width="450px"
      :close-on-click-modal="false"
    >
      <el-row class="form-item">
        <el-col :span="6">
          <span>订单状态：</span>
        </el-col>
        <el-col :span="16">
          <el-select v-model="state">
            <el-option :value="3" label="取消打回背包"></el-option>
            <el-option :value="2" label="处理通过"></el-option>
            <el-option :value="12" label="卖回变成余额"></el-option>
            <el-option :value="36" label="商城手动发货确认"></el-option>
            <el-option :value="1" label="手动发货"></el-option>
            <el-option
              :value="4"
              label="机器人报价中"
              v-if="GLOBAL.kefu_flag"
            ></el-option>
            <!-- <el-option :value="40" label="已发送"></el-option> -->
            <!-- <el-option :value="5" label="报价成功"></el-option> -->
            <!--						<el-option :value="31" label="重新购买因zbt余额不足订单"></el-option>-->
            <!--						<el-option :value="34" label="取消因zbt余额不足订单"></el-option>-->
          </el-select>
        </el-col>
      </el-row>
      <el-row class="form-item" v-if="query.type === 1">
        <el-col :span="6">
          <span>用户交易URL：</span>
        </el-col>
        <el-col :span="16">
          <span>{{ editInfo && editInfo.user.transaction_url }}</span>
          <i
            class="el-icon-s-order"
            v-if="editInfo"
            v-clipboard:copy="editInfo.user.transaction_url"
            v-clipboard:success="onCopy"
            style="font-size: 24px; cursor: pointer"
            title="复制到粘贴板"
          ></i>
        </el-col>
      </el-row>
      <el-row class="form-item" v-if="query.type === 1">
        <el-col :span="6">
          <span>用户QQ：</span>
        </el-col>
        <el-col :span="16">
          <span>{{ editInfo && editInfo.user.qq_id }}</span>
          <i
            class="el-icon-s-order"
            v-if="editInfo"
            v-clipboard:copy="editInfo.user.qq_id"
            v-clipboard:success="onCopy"
            style="font-size: 24px; cursor: pointer"
            title="复制到粘贴板"
          ></i>
        </el-col>
      </el-row>
      <el-row class="form-item">
        <el-col :span="6">
          <span>备注：</span>
        </el-col>
        <el-col :span="16">
          <el-autocomplete
            style="width: 280px"
            class="inline-input"
            v-model="remark"
            :fetch-suggestions="querySearch"
            placeholder="请输入内容"
          ></el-autocomplete>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleEdit = false">取 消</el-button>
        <el-button
          size="small"
          type="primary"
          @click="submit"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="visibleSelectEdit"
      title="修改选中订单状态"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-row class="form-item">
        <el-col :span="8">
          <span>订单状态：</span>
        </el-col>
        <el-col :span="16">
          <!-- <el-select v-model="state">
            <el-option :value="1" label="待处理"></el-option>
            <el-option :value="2" label="处理通过"></el-option>
            <el-option :value="3" label="处理未通过"></el-option>
            <el-option :value="40" label="已发送"></el-option>
            <el-option :value="4" label="机器人报价中"></el-option>
            <el-option :value="5" label="报价成功"></el-option>
            <el-option :value="6" label="报价失败"></el-option>
          </el-select> -->
          <el-select v-model="state">
            <el-option :value="3" label="取消打回背包"></el-option>
            <el-option :value="2" label="处理通过"></el-option>
            <el-option :value="12" label="卖回变成余额"></el-option>
            <el-option :value="36" label="商城手动发货确认"></el-option>
            <el-option :value="1" label="手动发货"></el-option>
            <el-option
              :value="4"
              label="机器人报价中"
              v-if="GLOBAL.kefu_flag"
            ></el-option>
          </el-select>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visibleSelectEdit = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="submitSelectEdit"
          :loading="buttonLoading"
          >确 定</el-button
        >
      </span>
    </el-dialog>

    <!-- ZBT购买 -->
    <el-dialog
      :visible.sync="visibleInfo"
      title="物品信息"
      width="400px"
      :close-on-click-modal="false"
    >
      <el-row class="form-item">
        <el-col :span="8">
          <span>物品名称：</span>
        </el-col>
        <el-col :span="16">
          <span>{{ manualInfo && manualInfo.name }}</span>
        </el-col>
      </el-row>
      <el-row class="form-item">
        <el-col :span="8">
          <span>品质：</span>
        </el-col>
        <el-col :span="16">
          <span v-if="manualInfo && manualInfo.shop_type === 3">{{
            getDotararity(manualInfo.rarity)
          }}</span>
          <span v-else>{{ manualInfo && manualInfo.quality }}</span>
        </el-col>
      </el-row>
      <el-row class="form-item">
        <el-col :span="8">
          <span>购买价格：</span>
        </el-col>
        <el-col :span="16">
          <span>{{ manualInfo && manualInfo.cost_price }}</span>
        </el-col>
      </el-row>
      <el-row class="form-item">
        <el-col :span="8">
          <span>最新最低价格：</span>
        </el-col>
        <el-col :span="16">
          <span>{{ manualInfo && manualInfo.price }}</span>
        </el-col>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button
          size="small"
          type="primary"
          @click="handleShopManual"
          :loading="buttonLoading"
          >购买</el-button
        >
      </span>
    </el-dialog>

    <!-- ig购买 -->
    <IgGoods
      :visible="IGVisible"
      v-model="getPrizeInfo"
      :type="1"
      @close="IGVisible = false"
      @refresh="getData()"
    >
    </IgGoods>

    <!-- 选择第三方物品 -->
    <BuyThirdGoods
        v-model="thirdDialogInfo"
        :visible="thirdPartyVisible"
        @close="thirdPartyVisible = false"
        @callbackInfo="getGoodsInfo"
    ></BuyThirdGoods>
    <!-- 选择第三方物品2 -->
    <BuyThirdGoods2
        v-model="thirdDialogInfo2"
        :visible="thirdPartyVisible2"
        @close="thirdPartyVisible2 = false"
        @callbackInfo="getGoodsInfo"
    ></BuyThirdGoods2>
    <!-- 选择第三方物品3 -->
    <BuyThirdGoods3
        v-model="thirdDialogInfo3"
        :visible="thirdPartyVisible3"
        @close="thirdPartyVisible3 = false"
        @callbackInfo="getGoodsInfo"
    ></BuyThirdGoods3>
  </div>
</template>

<script>
import {
  mapActions
} from 'vuex'
import ranks from '../../utils/ranks'
import http, {
  patchData,
  server,
  postApiData,
  getApiData,
  patchApiData
} from '../../http'
import saveFile from '../../utils/saveFile'
import rarityList from '@/assets/js/rarityList' //dota稀有度
import IgGoods from '@/components/thirdPartyGoods/IgGoods'
import BuyThirdGoods from '@/components/thirdPartyGoods/buythirdgoods/BuyThirdGoods'
import BuyThirdGoods2 from '@/components/thirdPartyGoods/buythirdgoods/BuyThirdGoods2'
import BuyThirdGoods3 from '@/components/thirdPartyGoods/buythirdgoods/BuyThirdGoods3'


export default {
  components: {
    IgGoods,
    BuyThirdGoods,
    BuyThirdGoods2,
    BuyThirdGoods3
  },
  data() {
    return {
      thirdPartyVisible: false, //第三方物品购买弹窗显示标志
      thirdPartyVisible2: false, //第三方物品购买弹窗显示标志
      thirdPartyVisible3: false, //第三方物品购买弹窗显示标志
      thirdDialogInfo: undefined,//查询第三方物品传递的信息
      thirdDialogInfo2: undefined,//查询第三方物品传递的信息
      thirdDialogInfo3: undefined,//查询第三方物品传递的信息
      warningUserDialog: false, //显示预警用户加载按钮动画
      IGVisible: false, //购买IG物品弹窗显示标志
      loading: false,
      query: {
        page: 1,
        type: 1,
        delivery_type: 1, //发货类型
        is_goods: undefined,
        state: 1,
        uid: '',
        goods_type: undefined, //物品种类 1是csgo 2是dota
        user_name: '',
        name: '',
        start_time: '',
        end_time: '',
        user_tag: '',
        min_price: '',
        max_price: ''
      },
      rarityList: rarityList, //dota稀有度
      visibleEdit: false,
      visibleSelectEdit: false,//批量修改状态弹窗显示标志
      visibleInfo: false, //手动购买弹窗显示标志
      editInfo: undefined,
      manualInfo: undefined,
      state: undefined,
      ids: undefined,
      remark: '',
      buttonLoading: false,
      url: '',
      multipleSelection: [],
      // 扎比特
      zbtBalance: '',
      prizeName: '',
      itemId: '',
      extractId: '',
      loadingZbtPrize: false,
      loadingZbtSellProduct: false,
      visibleZbtSearch: false,
      visibleZbtSellProduct: false,
      dataList: [],
      dataMeta: {},
      sellPage: 1, // 扎比特商品-在售列表分页
      page: 1, // 扎比特饰品-列表分页
      //IG
      getPrizeInfo: {
        prizeName: undefined,
        orderId: undefined,
        market_hash_name: undefined,
      },
      showData: {
        lately_ten_deliver_amount: '',
        manual_confirm_amount: '',
      },
      mdsBanlance: '加载中.',
    }
  },
  methods: {
    ...mapActions(['getExtractOrderList']),
    getGoodsInfo(val) {
      //第三方购买物品反参
    },
    handleSelectionChange(val) {
      this.multipleSelection = val
    },
    handleSelectedChange() {
      if (this.multipleSelection.length >= 1) {
        this.visibleSelectEdit = true
      } else {
        this.$message.warning('请先选择要修改的数据')
      }
    },
    showWarningUser() {
      //将预警用户的信息标红
      this.warningUserDialog = true
      let params = {
        record_type: 'shop_buy'
      }
      getApiData('user_warning', params)
        .then(res => {
          this.getData()
        }).finally(() => {
          this.warningUserDialog = false
        })
    },
    //显示发货金额
    showDeliveryAmount() {
      getApiData('shop_deliver_amount')
        .then(res => {
          this.showData.manual_confirm_amount = res.manual_confirm_amount//待发货金额
          this.showData.lately_ten_deliver_amount = res.lately_ten_deliver_amount//最近10分钟发货金额
        }).finally(() => {
        })
    },
    submitSelectEdit() {
      this.buttonLoading = true
      const ids = this.multipleSelection.map((item) => {
        return item.id
      })
      patchApiData(`shop_extract_multiple`, {
        ids: ids,
        state: this.state,
        remark: this.remark
      })
        .then(res => {
          this.$message.success('修改成功')
          this.visibleSelectEdit = false
          this.getData()
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    getRankColor(rank) {
      for (let item of ranks) {
        if (item.level === rank) {
          return item.color
        }
      }
    },
    getData() {
      this.loading = true
      let params = this.query
      params.delivery_type = this.query.state === 1 ? this.query.delivery_type : undefined
      getApiData(`shop_order`, params)
        .then(res => {
          this.dataList = res.data
          this.dataMeta = {
            current_page: res.current_page,
            per_page: res.per_page,
            total: res.total
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    handlePageChange(page) {
      this.query.page = page
      this.getData()
    },
    handleChange(row) {
      this.editInfo = row
      this.state = row.state
      this.ids = row.id
      this.remark = row.remark
      this.visibleEdit = true
    },
    handleShopManualInfo(rowInfo) {
      //ZBT购买
      // getApiData(`manual_get_price/${rowInfo.id}`).then(res => {
      //   this.manualInfo = res
      //   this.visibleInfo = true
      // })
      this.thirdPartyVisible = true
      this.thirdDialogInfo = JSON.parse(JSON.stringify(rowInfo))
    },
    handleShopManualInfo2(rowInfo) {
      //ZBT购买
      // getApiData(`manual_get_price/${rowInfo.id}`).then(res => {
      //   this.manualInfo = res
      //   this.visibleInfo = true
      // })
      this.thirdPartyVisible2 = true
      this.thirdDialogInfo2 = JSON.parse(JSON.stringify(rowInfo))
    },
    handleShopManualInfo3(rowInfo) {
      //ZBT购买
      // getApiData(`manual_get_price/${rowInfo.id}`).then(res => {
      //   this.manualInfo = res
      //   this.visibleInfo = true
      // })
      this.thirdPartyVisible3 = true
      this.thirdDialogInfo3 = JSON.parse(JSON.stringify(rowInfo))
    },
    handleShopManual() {
      //手动购买点击购买
      patchApiData(`shop_manual/${this.manualInfo.id}`).then(res => {
        if (res.code === 0) {
          this.$message.success('操作成功')
          this.getData()
        } else if (res.code === 1) {
          this.$message.error(res.err)
        }
      })
    },
    handleIGShopManualInfo(rowInfo) {
      //打开IG购买弹窗,赋值商品名字
      this.IGVisible = true
      this.getPrizeInfo = {
        prizeName: rowInfo.shop_prize.name,
        orderId: rowInfo.id,
        market_hash_name: rowInfo.shop_prize.market_hash_name,
      }
    },
    syncIG(row) {
      //同步IG状态
      patchApiData(`sync_ig_state/` + row.id).then(res => {
        if (res.err === 0) {
          this.$message.success('同步成功')
        } else {
          this.$message.error(res.msg)
        }
      })
    },
    submit() {
      this.buttonLoading = true
      patchApiData(`shop_extract/${this.ids}`, {
        state: this.state,
        remark: this.remark
      })
        .then(res => {
          if (!res.code) {
            this.$message.success(res.err)
            this.visibleEdit = false
            this.getData()
          } else {
            this.$message.error(res.err)
          }
        })
        .finally(() => {
          this.buttonLoading = false
        })
    },
    handleTypeChange(type) {
      this.query.page = 1
      if (type === 2) {
        this.query.state = 2
      } else {
        this.query.state = 1
      }
      this.getData()
    },
    handleIsGoodsChange(is_goods) {
      this.query.page = 1
      this.query.is_goods = is_goods
      this.getData()
    },
    handleStateChange() {
      this.query.page = 1
      this.getData()
    },
    handleDeliveryChange() {
      //改变发货类型
      this.query.page = 1
      this.getData()
    },
    changeType() {
      //改变物品类型
      this.query.page = 1
      this.getData()
    },
    handleSearch() {
      this.query.page = 1
      this.getData()
    },
    onCopy() {
      this.$message.success('已成功复制到粘贴板')
    },
    handleExport() {
      http
        .post(
          server + 'extract_export', {
          ...this.query,
          page: undefined
        }, {
          responseType: 'arraybuffer'
        }
        )
        .then(res => {
          saveFile(res, {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            name: '提取订单记录.xlsx'
          })
        })
    },
    getZbtBalance(row) {
      getApiData(`zbt/balance`)
        .then(res => {
          this.zbtBalance = res.data.data
        })
    },
    zbtSearch(row) {
      this.visibleZbtSearch = true
      this.prizeName = row.prize.name
      this.extractId = row.id
    },
    getZbtSearch(row) {
      this.loadingZbtPrize = true
      getApiData(`zbt/search`, {
        keyword: this.prizeName,
        page: this.page,
        limit: 15
      })
        .then(res => {
          this.zbtPrizeList = res.list
          this.zbtPrizeMeta = res
        })
        .finally(() => {
          this.loadingZbtPrize = false
        })
    },
    showzbtSell(row) {
      this.visibleZbtSellProduct = true
      this.itemId = row.itemId
      this.getZbtSellProduct()
    },
    getZbtSellProduct(row) {
      this.loadingZbtSellProduct = true
      getApiData(`zbt/sell_product`, {
        itemId: this.itemId,
        page: this.sellPage
      })
        .then(res => {
          this.zbtSellProductList = res.list
          this.zbtSellProductMeta = res
        })
        .finally(() => {
          this.loadingZbtSellProduct = false
        })
    },
    zbtDeliver(row) {
      postApiData(`zbt/buy/` + this.extractId, {
        productId: row.id,
        buyPrice: row.sellerPrice,
        delivery: row.delivery
      })
        .then(res => {
          this.$message.success('购买成功')
          this.visibleZbtSellProduct = false
          this.visibleZbtSearch = false
          this.getData()
        })
        .finally(() => {
          this.loadingZbtPrize = false
        })
    },
    handlePrizePageChange(page) {
      this.page = page
      this.getZbtSearch()
    },
    handleSellPageChange(page) {
      this.sellPage = page
      this.getZbtSellProduct()
    },
    closeZbtSearch() {
      this.page = 1
      this.zbtPrizeMeta = {}
      this.zbtPrizeList = []
    },
    closeZbtSell() {
      this.sellPage = 1
      this.zbtSellProductMeta = {}
      this.zbtSellProductList = []
    },
    pathToUser(id) {
      let routeData = this.$router.resolve({
        path: `/user/${id}`
      })
      window.open(routeData.href, '_blank')
    },
    getDotararity(num) {
      //匹配dota的稀有度
      for (let item of this.rarityList) {
        if (item.val === num) {
          return item.text
        }
      }
      return '无'
    },
    querySearch(queryString, cb) {
      let restaurants = [
        { "value": "交易链接错误，请修改后重新购买" },
        { "value": "交易链接错误，请修改后重新提取" },
        { "value": "商品暂时缺货，请更换饰品提取" },
        { "value": "交易链接封禁，请更换交易链接" },
      ];
      cb(restaurants);
    },
    tableRowClassName({ row, rowIndex }) {
      //更具情况给表格行加颜色
      if (row.shop_prize.goods_type === 3) {
        return 'warning-row';
      }
      return '';
    },
    getMdsBalance() {
      getApiData(`mds/get_blance`, {})
          .then(res => {
            if (res.code == 0) {
              this.mdsBanlance = res.data.balance;
            }
          })
          .finally(() => {
            this.loading = false
          })
    },

    increaseConfirmed(row) {
      this.buttonLoading = true
      patchApiData(`increase`, {id: row.id, state: 1}).then(res => {
        if (!res.code) {
          this.$message.success(res.err)
          this.visibleEdit = false
          this.getData()
        } else {
          this.$message.error(res.err)
        }
      }).finally(() => {
        this.buttonLoading = false
      })
    },
    increaseRefused(row) {
      this.buttonLoading = true
      patchApiData(`increase`, {id: row.id, state: 2}).then(res => {
        if (!res.code) {
          this.$message.success(res.err)
          this.visibleEdit = false
          this.getData()
        } else {
          this.$message.error(res.err)
        }
      }).finally(() => {
        this.buttonLoading = false
      })
    },
  },
  created() {
    this.getData();
    this.getMdsBalance();
  }
}

</script>

<style>
.el-table .warning-row {
  background: rgb(248, 228, 174);
}

.el-table .success-row {
  background: #f0f9eb;
}

.prize-list .el-icon-view,
.prize-list .el-icon-wallet {
  position: absolute;
  right: 5px;
  top: 5px;
  font-size: 16px;
  width: 24px;
  height: 24px;
  border-radius: 12px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: center;
  -ms-flex-pack: center;
  justify-content: center;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
  color: #fff;
  background-color: #409eff;
  cursor: pointer;
  -webkit-transition: all 0.3s;
  transition: all 0.3s;
}
</style>
